export default __webpack_public_path__ + "static/media/Group_12509.d5b8972a.png";